<template>
	<div style="background-color: #fff;width: 100vw;height: 100vh;">
		<Header :isHome="false"></Header>
		<div class="container" style="padding: 10rem 0 10rem;">
			<div class="row" style="align-items: center;justify-content: center;">
				<div style="display: flex;justify-content: center;flex-direction: column;width: 27rem;" class="mobile-style">
					<div class="r-title">
						<img src="../../assets/imgs/news/news-title-bg.png" class="r-title-bg">
						<span style="z-index: 1;position: relative;">password</span>
					</div>
					
					<div>
						<div>
							<div class="box-name">New Password:</div>
							<input class="box-input" type="password" v-model="newpwd" placeholder="New Password">
						</div>
						<div style="margin-top: 2rem;">
							<div class="box-name">Confirm New Password:</div>
							<input class="box-input" type="password" v-model="cpwd" placeholder="Confirm New Password">
						</div>
						
						<div style="background: linear-gradient(90deg, #31FFDA 0%, #00EDD8 100%);border-radius: 0.2rem;display: flex;align-items: center;justify-content: center;font-size: 1.2rem;
								margin-top: 2rem;cursor: pointer;font-weight: bold;border: none;" class="box-input" @click="save">
							save
						</div>
					</div>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	
			import axios from 'axios'
			import Header from '/src/components/header.vue'
			import Footer from '/src/components/footer.vue'
			import {baseUrl} from '../../assets/js/public.js'
		import md5 from 'js-md5'
		export default {
			data() {
				return {
					code:'',
					newpwd:'',
					cpwd:'',
				}
			},
			components: {
				Header,
				Footer
			},
			methods: {
				save(){
					if(this.newpwd != this.cpwd){
						// alert('password different')
						this.$bus.$emit('message',{
							type:1,
							msg:'password different'
						})
					}else if(this.newpwd==''||this.cpwd==''){
						// alert('enter your password')
						this.$bus.$emit('message',{
							type:1,
							msg:'enter your password'
						})
					}else{
						let params = {
							password: md5(this.newpwd),
							rePassword:md5(this.cpwd),
							// code: this.code
						}
						this.request({
							method: 'post',
							url: '/gci/auth/resetPassword/'+this.code,
							data:params
						}).then(res => {
							// alert(res.msg)
							if(res.status == 0){
								this.$router.push({name:'home'})
								this.$bus.$emit('message', {
									type:2,
									msg:res.msg
								})
							}else{
								this.$bus.$emit('message', {
									type:3,
									msg:res.msg
								})
							}
						}).catch(error => {
							console.error(error.response)
						})
					}
				},
			},
			mounted() {
				this.code = this.$route.query.code
				
			}
		}
</script>

<style scoped lang="scss">
	.box-name{
		color: #333;font-size: 1rem;margin-top: 1rem;font-weight: bold;
	}
	.box-input{
		border: 1px solid #eee;padding: 0.5rem;background-color: #fff;margin-top: 1rem;width: 100%;font-size: 1rem;border-radius: 0.2rem;
	}
	input::placeholder{
		color: #999999;opacity: 0.6;font-size: 0.8rem;
	}
	.r-title{
		height: 3rem;
		font-size: 1.5rem;
		font-weight: bold;
		position: relative;
		.r-title-bg{
			min-width: 13rem;position: absolute;left: -0.5rem;top: -3rem
		}
	}
	@media (max-width:767px) {
		.mobile-style{
			width: 100vw !important;
			padding: 1rem;
		}
	}
</style>